import { render, staticRenderFns } from "./CustomerImport.vue?vue&type=template&id=7af5e0c1&scoped=true&"
import script from "./CustomerImport.vue?vue&type=script&lang=ts&"
export * from "./CustomerImport.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerImport.vue?vue&type=style&index=0&id=7af5e0c1&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af5e0c1",
  null
  
)

export default component.exports